import React from "react";
import { useParams } from "react-router-dom";
import FeatureTopBarPage from "./FeatureTopBar/FeatureTopBarPage";
import BlogFeaturePage from "./BlogsFeature/BlogFeaturePage";

export default function FeatureFlowDecider() {
  const params = useParams();
  const featuresHavingTopBar = [
    "mindset-source",
    "training-source",
    "hr",
    "leaders-in-the-industry",
  ];
  if (featuresHavingTopBar.includes(params.feature_slug)) {
    return <FeatureTopBarPage />;
  } else {
    return (
      <>
        <BlogFeaturePage />
      </>
    );
  }
}
